import { DrbConfirm } from '~/web-components/drb-confirm/drb-confirm-helpers';
import { AiInput } from '~/shared/ai-input/ai-input';
import { FormHandler } from '~/shared/utils/form-handler';
import { ScreenTransitions } from '~/shared/utils/screen-transitions';

// eslint-disable-next-line import/no-unresolved
import alertIcon from '~/assets/icons/v2-alert-pink.svg?raw';

export class ServiceRequestDialogAi {
  constructor(dialog) {
    this.dialog = dialog;
    this.serviceDetailsAiInstance = this.initServiceDetailsAiInput();
    if (!this.dialog || !this.serviceDetailsAiInstance) return;

    this.initHelpMeStartForm();
    this.bindImproveWhatIWroteAction();
    this.bindHelpMeStartAction();
    this.bindRevertButton();
  }

  initServiceDetailsAiInput() {
    const serviceDetailsInput = this.dialog.querySelector('[data-service-request-input]');
    const inputWrapper = serviceDetailsInput?.closest('[data-write-with-ai-wrapper]');
    const requestId = inputWrapper?.querySelector('turbo-cable-stream-source')?.getAttribute('data-request-id');

    if (!serviceDetailsInput || !requestId) {
      console.error('Missing required parameters: serviceDetailsInput or requestId');
      return null;
    }

    return new AiInput({
      contextElement: inputWrapper,
      input: serviceDetailsInput,
      requestId,
      onError: (error, { action }) => {
        console.error('AI generation error:', error);
        if (action === 'build_service_request') this.showHelpMeStartPanel(true);

        DrbConfirm.open({
          title: 'Something went wrong. Please try again.',
          iconHtml: alertIcon,
          centered: true,
          cancelText: '',
          confirmText: 'Close',
        });
      },
    });
  }

  initHelpMeStartForm() {
    const form = this.dialog.querySelector('form[data-help-me-start-request-form]');
    if (!form) return;

    const formHandler = new FormHandler(form, {
      onBeforeSubmit: (data) => {
        const path = form.getAttribute('data-help-me-start-request-path');
        this.showHelpMeStartPanel(false);

        this.serviceDetailsAiInstance.generateContent('build_service_request', path, {
          notes: '', // backend requires at least an empty value
          ...data,
        });

        return false;
      },
      arrayFields: ['styles'],
    });
    const stylesSelect = form.querySelector('[data-styles-select]');

    formHandler.pristineValidation?.addValidator(
      stylesSelect,
      (value) => value.length > 0 && value.length <= 3,
      'Please select between 1 and 3 categories',
    );
  }

  bindImproveWhatIWroteAction() {
    const improveButton = this.serviceDetailsAiInstance.contextElement.querySelector('[data-ai-action="improve"]');

    improveButton?.addEventListener('click', (e) => {
      const form = e.target.closest('form');
      if (!form?.pristineValidation?.validate(this.serviceDetailsAiInstance.input)) return;

      const path = form.getAttribute('data-ai-request-path');
      const designerName = form.getAttribute('data-designer-name');
      const serviceTitle = this.dialog.querySelector('#service-title')?.value;
      const serviceDescription = this.dialog.querySelector('#service-description')?.value;

      const inputs = {
        input_text: this.serviceDetailsAiInstance.input.value,
        designer_name: designerName,
        service_title: serviceTitle,
        service_description: serviceDescription,
      };

      this.serviceDetailsAiInstance.generateContent('improve_service_request', path, inputs);
    });
  }

  bindRevertButton() {
    const revertButton = this.serviceDetailsAiInstance.contextElement.querySelector('[data-ai-input-revert-button]');
    revertButton?.addEventListener('click', () => this.serviceDetailsAiInstance.revertContent());
  }

  showHelpMeStartPanel(show) {
    const serviceScreen = this.dialog?.querySelector('[data-screen="service"]');
    const helpMeStartScreen = this.dialog?.querySelector('[data-screen="help-me-start"]');

    ScreenTransitions.transitionToScreen({
      targetScreen: show ? helpMeStartScreen : serviceScreen,
      type: show ? 'slide-left' : 'slide-right',
    });
  }

  bindHelpMeStartAction() {
    const helpMeStartButton = this.serviceDetailsAiInstance.contextElement.querySelector('[data-ai-action="help_me_start"]');
    helpMeStartButton?.addEventListener('click', () => this.showHelpMeStartPanel(true));
  }
}
